<template>
    <v-card flat tile class="fill-height">
        <v-card-text>
            <v-row>
                <template v-for="(page, index) in pages">
                    <v-col :key="page._id">
                        <side-item
                            v-bind="{
                                page,
                                value,
                                index,
                            }"
                            @click="$emit('input', index)"
                        />
                    </v-col>
                </template>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import SideItem from "./side/side-item.vue";

export default {
    components: {
        SideItem,
    },
    props: {
        value: { type: Number, default: 0 },

        pages: { type: Array, default: () => [] },
    },
};
</script>

<style></style>
